// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"242":"2652d81c701618a8ac8c","624":"5220865adce1c8b066af","839":"fde973b77878afc1b84c"}[chunkId] + ".js";
};